export default "__VITE_ASSET__bc0468eb__"